import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './KioskVerifyMeLayout.styles';
import {
  KioskFooter,
  KioskHeader,
  KioskVerifyMeMain,
  KioskIdelScreen
} from '..';

export class KioskVerifyMeLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classNames(classes.container)}>
        <KioskHeader />
        <KioskVerifyMeMain />
        <KioskFooter customFooterBottom="0%" />
        <KioskIdelScreen />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(KioskVerifyMeLayout);
